const feedBackData = [
    {
      whoFirst: 'Co-Founder,',
      whoLast: 'IoT Software Firm',
      score: {
        quality: 5.0,
        schedule: 4.5,
        cost: 4.5,
        willingToRefer: 5.0
      },
      imgFlag: require('../../assets/Slider/united-states.png'),
      textHead:
        '«The OS-systems team works proactively to solve problems quickly and thoroughly»',
      description:
        'The OS-systems team employs a broad variety of skill sets to create high-quality, cohesive deliverables. The team integration process has been fluid and effective. Emphases on collaboration and communication have been key in developing a long-term partnership.'
    },
    {
      whoFirst: 'Co-Founder, Data',
      whoLast: 'Analytics Company',
      score: {
        quality: 4.5,
        schedule: 4.5,
        cost: 5,
        willingToRefer: 5
      },
      imgFlag: require('../../assets/Slider/australia.svg'),
      textHead:
        '«They had a really good understanding of what we wanted to achieve from a user experience point of view»',
      description:
        'Although the platform is still in the pre-launch stages, OSSystem earned positive feedback on the professionalism and attractiveness of the UI design. Their quality of work, daily communication, and proactiveness has provided depth and range in their professional relationship.'
    },
    {
      whoFirst: 'CEO & Co-Founder,',
      whoLast: 'Dating App',
      score: {
        quality: 5,
        schedule: 5,
        cost: 5,
        willingToRefer: 5
      },
      imgFlag: require('../../assets/Slider/switzerland.svg'),
      textHead:
        '«OS-system’s background in our core technologies is what we were looking for in a partnership»',
      description:
        'OSSystem effectively completed all the tasks requested. The app is updated and currently bug-free. Their team’s commitment and work quality were outstanding. They streamlined the project, striving to fix any inconsistencies in their work. Expect a true partnership when working with OSSystem.'
    },
    {
      whoFirst: 'Martin Karlsson',
      whoLast: 'Co-Founder',
      score: {
        quality: 4.6,
        schedule: 4.6,
        cost: 4.8,
        willingToRefer: 4.7
      },
      imgFlag: require('../../assets/Slider/sw.png'),
      textHead:
        '«OSSystem team delivered more than can be expected to meet the tough real-time requirements of this project»',
      description:
        "The code delivered was of excellent quality and the issues that came up were fixed and turned around really quickly. Developers, who work for OS-system, get the job done regardless of it's late at night or weekend."
    },
    {
      whoFirst: 'Mark W,',
      whoLast: 'Co-Founder',
      score: {
        quality: 5,
        schedule: 5,
        cost: 5,
        willingToRefer: 5
      },
      imgFlag: require('../../assets/Slider/australia.svg'),
      textHead:
        '«I highly recommend, and will not hesitate to use again for future jobs»',
      description:
        'The project was completed very successfully - starting with Proof of Concept, through to final Enterprise Platform development. Highly professional, diligent and customer-focused. Great depth and breadth of skill sets, which helped de-risk the project, while also giving us resource flexibility.'
    }
  ];
  
  export default feedBackData;